export default "__VITE_ASSET__BhGZMpSL__"